import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7767666e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" × ")
const _hoisted_2 = { class: "container d-flex justify-content-center h-100" }
const _hoisted_3 = { class: "row w-100" }
const _hoisted_4 = {
  key: 0,
  class: "d-none d-lg-block col-lg-3 col-xl-2"
}
const _hoisted_5 = { class: "modal__navigation m-0 p-0" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Main ")
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Gallery ")
const _hoisted_10 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Did you know? ")
const _hoisted_12 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Impact ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_Pill = _resolveComponent("Pill")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-bg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["modal", [{'modal--minimal': _ctx.minimal}]])
            }, [
              _createVNode(_component_btn, {
                class: "modal__close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (!_ctx.minimal)
                    ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
                        _createElementVNode("ul", _hoisted_5, [
                          _createElementVNode("li", _hoisted_6, [
                            _createVNode(_component_Pill, {
                              red: "",
                              class: "w-100 mb-16",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollTo('#main')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", _hoisted_8, [
                            _createVNode(_component_Pill, {
                              red: "",
                              class: "w-100 mb-16",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollTo('#imagery')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_9
                              ]),
                              _: 1
                            })
                          ]),
                          (_ctx.dyk)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                _createVNode(_component_Pill, {
                                  red: "",
                                  class: "w-100 mb-16",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollTo('#didyouknow')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.impact)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                                _createVNode(_component_Pill, {
                                  red: "",
                                  class: "w-100 mb-16",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollTo('#impacts')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    ref: "body",
                    class: _normalizeClass(["modal__body pt-1", [_ctx.minimal ? 'col-12' : 'col-12 col-lg-7 col-xl-8 offset-xl-1']])
                  }, [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ], 2)
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}